export default "__VITE_ASSET__C12$NRgC__"